'use client'
import React, { useState } from 'react'

export default function ShowMore({ desc }: { desc: string | undefined }) {
  const [showMore, setShowMore] = useState(false)

  const handleDesc = () => {
    setShowMore(!showMore)
  }
  return (
    <>
      {desc && (
        <div
          className={`${!showMore && 'box h-32 overflow-hidden text-ellipsis '} big-text`}
          dangerouslySetInnerHTML={{ __html: desc }}
        ></div>
      )}

      {desc && desc.length > 550 && (
        <div>
          <a
            className={'text-primary-500 hover:text-primary-500 sm:px-1 sm:py-2.5 sm:text-xs'}
            onClick={handleDesc}
          >
            {showMore ? 'Read Less' : 'Read More'}
          </a>
        </div>
      )}
    </>
  )
}
